<template>
  <!-- Search Section -->
  <li class="nav-item search-container">
    <div class="search-box">
      <div class="search-input-group">
        <div v-show="!statusEnrollment">
          <label for="departamentDropdown">Departamento</label>
          <Dropdown
            id="departamentDropdown"
            v-model="selectedDepartament"
            :options="departments"
            optionLabel="lugar"
            optionValue="id"
            placeholder="Seleccione un departamento"
            :class="{ 'p-invalid': searchError }"
            class="full-width"
          />
          <Button
            icon="pi pi-search"
            label="Buscar"
            @click="findRue"
            :loading="searchLoading"
          />
        </div>
        <Button
          icon="pi pi-file"
          label="Reporte Clasificados"
          severity="success"
          v-show="statusEnrollment"
          @click="downloadReport"
          :loading="searchLoading"
        />
      </div>
      <small class="p-error" v-if="searchError">{{ searchError }}</small>
    </div>
  </li>

  <!-- Student Details Dialog -->
  <Dialog
    v-model:visible="visible"
    modal
    header="Registro de Estudiante"
    :style="{ width: '70vw' }"
    :breakpoints="{ '1199px': '80vw', '575px': '95vw' }"
  >
    <!-- Student Information -->
    <StudentInfoPanel :student="student" :loading="studentLoading" />

    <!-- Registration Info (Area only) -->
    <Panel header="Datos de inscripción" class="registration-panel">
      <div class="form-grid two-panel-grid">
        <div class="info-panel">
          <h4 class="info-header">
            <i class="pi pi-info-circle"></i> Información de inscripción
          </h4>
          <div class="field">
            <label>Área de inscripción:</label>
            <span>{{ areaName }}</span>
          </div>
        </div>
        <!-- Right: Action Buttons -->
        <div
          class="form-actions"
          style="align-self: flex-end; justify-content: flex-end"
        >
          <Button
            type="button"
            label="Cancelar"
            severity="secondary"
            @click="visible = false"
          />
          <Button
            type="button"
            label="Registrar"
            icon="pi pi-check"
            class="ml-2"
            @click="registerStudent"
            :disabled="!student.competitorId"
          />
        </div>
      </div>
    </Panel>
  </Dialog>
</template>

<script setup>
import { ref, computed } from "vue";
import StudentInfoPanel from "./StudentInfoPanel.vue";

const emit = defineEmits(["selectSchool", "getReport"]);

const props = defineProps({
  statusEnrollment: Boolean,
  departments: Array,
});

const selectedDepartament = ref(null);
const searchError = ref("");
const searchLoading = ref(false);
const studentLoading = ref(false);
const visible = ref(false);
const student = ref({});

const areaName = computed(() => {
  if (!student.value || !student.value.area_id) return "";
  // You may want to map area_id to a name here if needed
  return student.value.area_id;
});

const findRue = () => {
  if (!selectedDepartament.value) {
    searchError.value = "Por favor seleccione un departamento";
    return;
  }
  emit("selectSchool", selectedDepartament.value);
};

function downloadReport() {
  emit("getReport");
}

function registerStudent() {
  // Implement registration logic here
}
</script>

<style scoped>
.search-container {
  padding: 1.5rem;
}

.search-box {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.search-input-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.search-input-group :deep(.p-inputtext),
.search-input-group :deep(.p-button) {
  width: 100%;
  min-width: 0;
  flex: unset;
}

.registration-panel {
  margin-top: 1.5rem;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

.two-panel-grid {
  align-items: flex-start;
}

.info-panel {
  background: #f8fafc;
  border-radius: 1rem;
  padding: 2rem 1.5rem;
  margin-bottom: 2rem;
  box-shadow: 0 2px 8px rgba(60, 60, 60, 0.06);
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.info-header {
  font-size: 1.2rem;
  font-weight: 600;
  color: #6366f1;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
  .two-panel-grid {
    grid-template-columns: 1fr;
  }
  .info-panel {
    margin-bottom: 1.5rem;
  }
}

.field {
  margin-bottom: 1.5rem;
}

.full-width {
  width: 100% !important;
  min-width: 0;
  box-sizing: border-box;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: var(--text-color-secondary);
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid var(--surface-border);
}

.p-error {
  color: var(--red-500);
  font-size: 0.875rem;
  margin-top: 0.25rem;
  display: block;
}
</style>

<style>
.swal2-container {
  z-index: 3000 !important;
}
</style>
